import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Loading } from '../React/features/Loading';

export const renderLoading = () => {
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // コンテナ要素にクラス付与
  viewContainer.classList.add('loading');

  // チャットルートにコンテナ要素をappendする
  document.querySelector('body').appendChild(viewContainer);

  // appendしたコンテナ要素にJsxをレンダリングする
  viewRoot.render(<Loading />);
};
